import { withIcon } from './withIcon';

const CartSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.85 22.5H6.15002C3.67502 22.5 1.65002 20.475 1.65002 18V17.85L2.10002 5.85C2.17502 3.375 4.20002 1.5 6.60002 1.5H17.4C19.8 1.5 21.825 3.375 21.9 5.85L22.35 17.85C22.425 19.05 21.975 20.175 21.15 21.075C20.325 21.975 19.2 22.5 18 22.5C18 22.5 17.925 22.5 17.85 22.5ZM6.60002 3C4.95002 3 3.67502 4.275 3.60002 5.85L3.15002 18C3.15002 19.65 4.50002 21 6.15002 21H18C18.825 21 19.575 20.625 20.1 20.025C20.625 19.425 20.925 18.675 20.925 17.85L20.475 5.85C20.4 4.2 19.125 3 17.475 3H6.60002Z"
      fill="var(--v3-black-100)"
    />
    <path
      d="M12 10.5C9.075 10.5 6.75 8.175 6.75 5.25C6.75 4.8 7.05 4.5 7.5 4.5C7.95 4.5 8.25 4.8 8.25 5.25C8.25 7.35 9.9 9 12 9C14.1 9 15.75 7.35 15.75 5.25C15.75 4.8 16.05 4.5 16.5 4.5C16.95 4.5 17.25 4.8 17.25 5.25C17.25 8.175 14.925 10.5 12 10.5Z"
      fill="var(--v3-black-100)"
    />
  </svg>
);

export const Cart = withIcon(CartSvg);
